import { MailOutlined, SendOutlined } from "@ant-design/icons";
import { Button, Divider, Form, Input, message } from "antd";
import { useTranslation } from "react-i18next";
import { FloatingLabelField } from "../../components/FloatingLabelField";
import { useState } from "react";
import { requestResetPassword } from "../../apis/loginApi";

export default function ForgotPassword() {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const onFinish = async ({ email }) => {
    setLoading(true);
    try {
      await requestResetPassword(email);
      message.success(t("Please check your email"));
    } catch (e) {
      message.error(t(e?.data?.responseText || "Failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 !px-5">
      <div className="bg-white !p-6 lg:!p-8 shadow rounded-xl w-11/12 lg:w-2/5">
        <div className="w-full flex flex-col items-center gap-2 mb-2">
          <img src="/assets/img/brand/logo.png" width={180} alt="" />
          <div className="rounded-xl text-center">
            <Divider className="!px-14 mt-0 !mb-4 !border-main">
              <MailOutlined className="text-2xl text-main" />
            </Divider>
            <span>
              {t("Enter your user account's verified email address and we will send you a password reset link")}
            </span>
          </div>
        </div>
        <Form layout="vertical" form={form} onFinish={onFinish} size="large">
          <Form.Item name="email" rules={[{ required: true, type: "email" }]}>
            <FloatingLabelField label={t("Email")}>
              <Input />
            </FloatingLabelField>
          </Form.Item>
          <Form.Item className="!mt-8 mb-2">
            <Button
              type="primary"
              htmlType="submit"
              className="flex-center !bg-main"
              block
              icon={<SendOutlined />}
              loading={loading}
            >
              {t("Send")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
